import React from 'react';
import styled from '@emotion/styled';
import Tooltip from 'app/components/Tooltip';
import { Space, TooltipProps } from 'antd';
import { Text } from 'app/components/Typography/Text';
import { Caption } from 'app/components/Typography/Caption';
import { JOB_STATUS } from 'app/components/Status/JobStatus';

const StyledTooltip = styled(Tooltip)``;
const Block = styled.div`
  display: flex;
  flex-direction: column;
  h5,
  span.ant-typography {
    color: #fff;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.005em;
    text-align: left;
    margin-bottom: 0;
  }
  > div {
    &:last-of-type {
      span.ant-typography {
        color: #8991a0;
        font-size: 10px;
        font-weight: 400;
        line-height: 12px;
        letter-spacing: 0.01em;
        text-align: left;
      }
      ul {
        padding-left: 4px;
        li {
          list-style: none;
        }
        li:before {
          content: '- ';
        }
      }
    }
  }
`;
const TooltipEvent = (
  props: Partial<TooltipProps> & {
    factory: {
      address: string;
      name: string;
    };
    event: any;
  }
) => {
  const { factory, event, ...rest } = props;
  const selectionDates =
    (event as any).resource.inspectionDates?.map(
      ({ date }: { date: moment.Moment }) => {
        return date.format('DD/MM/YYYY');
      }
    ) ?? [];
  const totalDay = event.resource.manDay;
  return (
    <StyledTooltip
      title={
        <Block>
          <Space size={0} direction="vertical">
            <h5 className="address">{factory?.address}</h5>
            <Space direction="vertical" size={0}>
              <Text className="name">{factory?.name}</Text>
              <Text>
                {selectionDates.join(', ')} ({totalDay}{' '}
                {`${totalDay > 1 ? 'days' : 'day'}`})
              </Text>
            </Space>
          </Space>
          <Space direction="vertical" size={0}>
            <div>
              <Caption>{(event as any).resource?.inspectorName}</Caption>
              <ul>
                <li>
                  <Caption>
                    {
                      (JOB_STATUS as any)[
                        ((event as any).resource?.status as string) || 'default'
                      ]
                    }
                  </Caption>
                </li>
              </ul>
            </div>
          </Space>
        </Block>
      }
      placement="bottom"
      {...rest}
    ></StyledTooltip>
  );
};

export default TooltipEvent;
